{
	"clientInvoices": {
		"email": "Email",
		"issuedAt": "Fecha y hora",
		"links": "Links",
		"loading": "Cargando...",
		"name": "Cliente",
		"noInvoices": "No hay notas emitidas para mostrar",
		"onSubmitEmailForm": "Enviar facturas por email",
		"openCoupon": "Abrir Cupón",
		"openPdf": "Abrir PDF",
		"send": "Enviar",
		"somethingWrong": "Algo salió mal",
		"submitButton": "Emitir notas",
		"title": "Facturas de {{clientName}}",
		"updatePage": "Actualice la página e inténtelo de nuevo"
	},
	"clientTransactions": {
		"buyers": "Compradores",
		"date": "Hora",
		"product": "Products",
		"refunded": "Devuelto?",
		"sellerName": "Seller",
		"title": "Extraer del cliente '{{clientName}}'"
	}
}
